import React from "react";
import PropTypes from "prop-types";
import * as types from "../../../constants/ComponentConstants";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";

import * as domainConstants from "../../../constants/DomainConstants";

const EnergetischDuurzaam = props => {

	const IS_ENERGETISCH_DUURZAAM = "Als de sportinfrastructuur, waarvoor subsidie aangevraagd wordt, één of meer EPN-eenheden bevat, moeten de functionele delen waar de sport beoefend wordt, na de sportinfrastructuurwerken voldoen aan het E-peil dat van toepassing zal zijn één jaar na de datum van de aanvraag van de omgevingsvergunning voor stedenbouwkundige handelingen of de stedenbouwkundige vergunning. Je voegt een engagementsverklaring toe bij de subsidieaanvraag over het voldoen aan de minimale energetische norm. ";
	const jaNeeNvt = [{ value: "121450000", label: 'Ja' }, { value: "121450001", label: 'Nee' }, { value: "121450002", label: "Niet van toepassing" }];

	const {
		minimaleEisen,
		disabled,
		errors,
		onChange,
		color,
		fileTypes,
		mapDeleteFile,
		mapDropFiles,
		getFilesForDossierComponent,
		hasFilesForDossierComponent,
		dossierType,
		sjablonen,
		fileSessionStarted,
		validationMessageType
	} = props;

	function getFilesForSjabloonComponent(component) {
		if (sjablonen) {
			const folder = sjablonen.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	return (
		<Fieldset title="Is het project energetisch duurzaam?">
			<RadioButtonGroup
				label=""
				labelInside
				tooltip={IS_ENERGETISCH_DUURZAAM}
				name="isHetProjectEnergetischDuurzaam"
				value={minimaleEisen.isHetProjectEnergetischDuurzaam}
				onChange={onChange}
				disabled={disabled}
				locked={hasFilesForDossierComponent(domainConstants.ComponentName.Engagementsverklaring)}
				items={jaNeeNvt}
				horizontal
				validationMessage={errors ? errors.isHetProjectEnergetischDuurzaam : ''}
				validationMessageType={validationMessageType} />
			{minimaleEisen.isHetProjectEnergetischDuurzaam === "121450000" || minimaleEisen.isHetProjectEnergetischDuurzaam == 121450000 ?
				<div>
					<FieldsetSubHeader>Engagementsverklaring</FieldsetSubHeader>
					<Row>
						<DownloadUploadFiles
							dossierId={minimaleEisen.dossierId}
							title="Sjabloon"
							size={6}
							disabled={disabled}
							tab={domainConstants.DocumentTab.MinimaleEisen}
							component={domainConstants.ComponentName.Engagementsverklaring}
							files={getFilesForSjabloonComponent(domainConstants.ComponentName.Engagementsverklaring)}
							color={color}
							fileSessionStarted={fileSessionStarted} />
						<DownloadUploadFiles
							dossierId={minimaleEisen.dossierId}
							tooltipIconColor={types.COLOR_WHITE}
							infrastructuurId={minimaleEisen.infrastructuur.id}
							title="Engagementsverklaring"
							size={6}
							disabled={disabled}
							color={color}
							tab={domainConstants.DocumentTab.MinimaleEisen}
							component={domainConstants.ComponentName.Engagementsverklaring}
							onDelete={mapDeleteFile(domainConstants.ComponentName.Engagementsverklaring)}
							onDrop={mapDropFiles(domainConstants.ComponentName.Engagementsverklaring)}
							files={getFilesForDossierComponent(domainConstants.ComponentName.Engagementsverklaring)}
							fileTypes={fileTypes.Engagementsverklaring}
							validationMessage={errors ? errors.ulEngagementsverklaring : ''}
							validationMessageType={validationMessageType}
							fileSessionStarted={fileSessionStarted} />
					</Row>
				</div>
				: ""}
		</Fieldset>
	);
};

EnergetischDuurzaam.propTypes = {
	minimaleEisen: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	fileTypes: PropTypes.object,
	mapDeleteFile: PropTypes.func.isRequired,
	mapDropFiles: PropTypes.func.isRequired,
	getFilesForDossierComponent: PropTypes.func.isRequired,
	hasFilesForDossierComponent: PropTypes.func.isRequired,
	dossierType: PropTypes.number.isRequired,
	fileSessionStarted: PropTypes.bool,
	sjablonen: PropTypes.array.isRequired,
	validationMessageType: PropTypes.string
};

export default EnergetischDuurzaam;